import { BaseCurrencyInput, Hairline, Label, Radio } from "@components";
import styles from "@styles/forms-flow/trigger.module.scss";
import classNames from "classnames/bind";

const css = classNames.bind(styles);

export const ContemplationInterval = ({ creative, onChangeCreative }) => {
  const onChangeType = (type) => {
    onChangeCreative &&
      onChangeCreative({
        contemplation: {
          ...creative?.contemplation,
          type: type,
        },
      });
  };

  const onChangeDayInterval = (days) => {
    onChangeCreative &&
      onChangeCreative({
        contemplation: {
          ...creative?.contemplation,
          dayInterval: days,
        },
      });
  };

  return (
    <div className={styles.triggerForm}>
      <Label>O usuário pode ser contemplado</Label>

      <div className={styles.options}>
        <div
          className={css({
            option: true,
            selected: creative?.contemplation?.type === "SEVERAL_TIMES",
          })}
          onClick={() => onChangeType("SEVERAL_TIMES")}
        >
          <div className="d-flex align-center">
            <Radio
              family="contemplation"
              value="SEVERAL_TIMES"
              checked={creative?.contemplation?.type}
            />
            <div className={styles.icon}>
              <i className="fal fa-repeat" />
            </div>
            <div className="d-flex flex-column">
              <p className={styles.type}>Várias vezes</p>
            </div>
          </div>
        </div>
      </div>

      {creative?.contemplation?.type === "SEVERAL_TIMES" && (
        <>
          <Hairline />
          <Label className="mt-30">Defina um intervalo de contemplação</Label>
          <BaseCurrencyInput
            label="Intervalo de contemplação"
            prefix=""
            design="two"
            suffix=" dias"
            precision={0}
            value={creative?.contemplation?.dayInterval}
            onChange={(days) => onChangeDayInterval(days)}
          />
        </>
      )}

      <div className={styles.options}>
        <div
          className={css({
            option: true,
            selected: creative?.contemplation?.type === "SINGLE_TIME",
          })}
          onClick={() => onChangeType("SINGLE_TIME")}
        >
          <div className="d-flex align-center">
            <Radio
              family="contemplation"
              value="SINGLE_TIME"
              checked={creative?.contemplation?.type}
            />
            <div className={styles.icon}>
              <i className="fal fa-circle-1" />
            </div>
            <div className="d-flex flex-column">
              <p className={styles.type}>Uma única vez</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
